module.exports = __webpack_public_path__ + "static/media/login.d792fa49.svg";